import { Content } from 'antd/es/layout/layout';
import CustomStep from './lib/CustomStep';
import { Button, Col, Descriptions, Empty, Flex, Row } from 'antd';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { notifyError, priceFormat } from '../../store/utils';
import { emitter, getStoreOrders, setStoreOrders } from '../../store/StoreUtils';
import { DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const CustomOrderList = () => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<any[]>([]);

  const createOrder = useCallback(async () => {
    try {
      setLoading(true);
    } catch (error: any) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const orderDelete = useCallback(
    (index: number) => {
      const items = orders.filter((o, idx) => idx !== index);
      setOrders(items);
      setStoreOrders(items);
      emitter.emit('localOrderChange');
    },
    [orders]
  );

  useEffect(() => {
    const orders = getStoreOrders();
    setOrders(orders);
  }, []);

  return (
    <Content className="custom-order-content">
      <CustomStep current={1} />
      <div className="step-container">
        {orders.map((order, index) => {
          return (
            <Row key={index} gutter={[24, 24]}>
              <Col span={24}>
                <Descriptions
                  title={
                    <Flex justify="space-between">
                      <h3>Захиалга {index + 1}</h3>
                      <DeleteOutlined onClick={() => orderDelete(index)} />
                    </Flex>
                  }
                >
                  <Descriptions.Item label="Игээгч" span={3}>
                    {order.senderFname}, {order.senderZipcodeNames.join(' ')}
                  </Descriptions.Item>
                  <Descriptions.Item span={3} label="Хүлээн авагч">
                    {order?.receiverFname}, {order?.receiverZipcodeNames.join(' ')}
                  </Descriptions.Item>
                  <Descriptions.Item span={3} label="Илгээмж">
                    {order.items.map((item: any) => {
                      return (
                        <div>
                          {item?.name} Тоо ширхэг: {item?.quantity} {item?.warningName}{' '}
                          {item?.weightTypeName} Үнэ: {item?.deliveryCost}
                        </div>
                      );
                    })}
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>
          );
        })}
        {orders.length ? (
          <Fragment>
            <Flex style={{ marginTop: 20 }} justify="end">
              <b>
                Нийт үнэ:{' '}
                {priceFormat(
                  orders.reduce(
                    (partialSum, order) =>
                      partialSum +
                      order.items.reduce(
                        (subSum: number, item: any) => subSum + item.deliveryCost,
                        0
                      ),
                    0
                  )
                )}
              </b>
            </Flex>
            <div style={{ textAlign: 'center' }}>
              <Button loading={loading} onClick={() => createOrder()} type="primary">
                Төлбөр төлөх
              </Button>
            </div>
          </Fragment>
        ) : (
          <div className="">
            <Empty
              style={{ minHeight: 250, marginTop: 50 }}
              description="Хадгалсан захиалга хоосон байна"
            >
              <Link to="/customer-order">
                <Button>Захиалга нэмэх</Button>
              </Link>
            </Empty>
          </div>
        )}
      </div>
    </Content>
  );
};

export default CustomOrderList;
